import React from 'react'
import TabAddAmenities from './page-components/Amenities/TabAddAmenities'
import TabViewAmenities from './page-components/Amenities/TabViewAmenities'
import MasterPageTab from './page-essential/MasterPageTab'
import SideNav from './page-essential/SideNav'

const Amenities = () => {
    return (
        <MasterPageTab addBtn='Add Amenites' viewBtn='View Amenities' addTab={<TabAddAmenities />} viewTab={<TabViewAmenities />} pageHeading={"Amenities"} pageDescription='Add/view/modify amenities' icon={null} />
    )
}

export default Amenities